import { saveOrganization, getOrganization, doAssociation, addChildOrg, toggleEdit, navigate, addChildOrgType } from '../../actions/organization';
import { loadDictionaries } from '../../actions/dictionary';
import { syncActions as externalAppSyncActions } from '../../actions/external-applications';
import { buildDispatchable } from '../../actions/_action-utilities';
import history from '../../history';
import { isTabViewOnly, isCaseConfigDeny } from '../../core/resources';
import { commonEnums, objectUtils } from '@codametrix/ui-common';
const { ResourceId } = commonEnums;
export const mapStateToProps = function(state) {
    const { organization, ui } = state;
    const viewOnly = isTabViewOnly(ui.AdminTabs, ResourceId.ORGANIZATIONS);
    const caseConfigDisable = isCaseConfigDeny(ui.context.user.roles || [], ui.context.activeContext?.organizationName);
    return {
        ...organization,
        auth: state.login.auth,
        viewOnly,
        caseConfigDisable
    };
};
export const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        toggleEdit: (bool)=>dispatch(toggleEdit(bool)),
        addChildOrg: (viewOnly, token, addChild, parentOrg, isAddChild)=>{
            runDispatchable(()=>{
                return dispatch(addChildOrg({
                    viewOnly,
                    token,
                    childOrgType: addChild,
                    parentOrg,
                    isAddChild
                }));
            });
        },
        navigate: (token, organization)=>{
            runDispatchable(()=>{
                return dispatch(navigate({
                    token,
                    organization
                }));
            });
        },
        navigateExternalApplication: (orgId)=>{
            runDispatchable(()=>{
                dispatch(externalAppSyncActions.selectOrgnization(orgId));
                history.push(`/cmx/admin/orgs/${orgId}/external-applications`);
            });
        },
        navigateCaseConfig: (orgId)=>{
            runDispatchable(()=>{
                history.push(`/cmx/admin/orgs/${orgId}/case-config`);
            });
        },
        navigateDictionaries: (org)=>{
            runDispatchable(()=>{
                //@ts-ignore
                return dispatch(loadDictionaries(org));
            });
        },
        doAssociation: (token, edits, newOrg)=>{
            runDispatchable(()=>{
                return dispatch(doAssociation({
                    token,
                    edits,
                    newOrg
                }));
            });
        },
        getOrganization: (payload)=>{
            runDispatchable(()=>{
                return dispatch(getOrganization(payload));
            });
        },
        doSave: (token, organization)=>{
            runDispatchable(()=>{
                return dispatch(saveOrganization({
                    token,
                    organization
                }));
            });
        },
        addChildOrgType: (childOrgType)=>dispatch(addChildOrgType(childOrgType))
    };
};
export const convertTimeZones = (items)=>items.map((item)=>({
            value: item,
            label: item
        }));
export const findOrganizationRelationship = (serviceLines, partial)=>{
    let sought;
    serviceLines.find((sl)=>{
        return sl.organizationRelationships.find((orgRel)=>{
            if (objectUtils.isMatch(orgRel, partial)) {
                sought = orgRel;
                return true;
            }
            return false;
        });
    });
    // @ts-ignore
    return sought;
};
